<div class="address-card">
    <h1 *ngIf="showAddressesHeading" class="address-card__addresses-heading">
        Addresses
        <img alt="" src="../../../../assets/icons/green-check-icon.svg" />
    </h1>
    <h6 class="address-card__title" *ngIf="title">
        {{ title }}
    </h6>
    <ul class="flex flex-col gap-2">
        <li>{{ address.fullName }}</li>
        <li>{{ address.streetLine1 }}</li>
        <li>{{ address.postalCode }}</li>
        <li>{{ getCountryName() }}</li>
    </ul>
    <ng-content></ng-content>
</div>
